import {useMutation, gql} from '@apollo/client'

export const MUTATE_ADD_TO_SAVED_PROSPECT_LIST = gql`
  mutation MUTATE_ADD_TO_SAVED_PROSPECT_LIST($listName: [String!]!, $constituentId: [String]!, $azureRole: String) {
    addToList(listName: $listName, constituentId: $constituentId, azureRole: $azureRole) {
      addToList {
        listName
        constituentId
      }
    }
  }
`

export function useAddToSavedProspectList() {
  return useMutation(MUTATE_ADD_TO_SAVED_PROSPECT_LIST, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
